import { render } from "./GlobalPopup.vue?vue&type=template&id=193ab7c0"
import script from "./GlobalPopup.vue?vue&type=script&lang=js"
export * from "./GlobalPopup.vue?vue&type=script&lang=js"

import "./GlobalPopup.vue?vue&type=style&index=0&id=193ab7c0&lang=css"

import exportComponent from "/var/www/project/coridor-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__